'use strict';/* global define */define('modules/globals/services/angular/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
function factory(){// jshint validthis:true
// jshint latedef:false
return window.angular;}module.exports=factory;});
